// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"5d967c3e","250":"39248091"}[chunkId] + ".chunk.js";
};